export class LoginCredentials {
    public email: string;
    public password: string;

    constructor(inEmail: string, inPassword: string) {
        this.email = inEmail;
        this.password = inPassword;
    }
}
